
import HttpClient from '../HttpService';

function getById(requestId) {
    return HttpClient.get(`/patients/${requestId}`);
}

function getByUUID(uuid) {
    return HttpClient.get(`/patients/uuid/${uuid}`);
}

function create(data) {
    return HttpClient.post(`/patients`, data);
}

function list(page, limit, data) {
    return HttpClient.post(`/patients/list?page=${page}&limit=${limit}`, { ...data });
}

function update(data) {
    return HttpClient.put(`/patients/uuid/${data.uuid}`, data);
}

function addFile(patientId, fileId) {
    return HttpClient.put(`/patients/${patientId}/files/${fileId}`);
}

function removeFile(patientId, fileId, data) {
    return HttpClient.delete(`/patients/${patientId}/files/${fileId}`, data);
}

function destroy(patientUUID) {
    return HttpClient.delete(`/patients/uuid/${patientUUID}`);
}

export default {
    destroy,
    list,
    create,
    update,
    addFile,
    getById,
    removeFile,
    getByUUID
}
